import './mailCodeSavingsOffer.scss';

import uniqueId from 'lodash/uniqueId';
import { ReactNode } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { locator } from '../../testing/e2e-locator/locator';
import { MailCodeSavingsOfferProps } from './types/MailCodeSavingsOfferProps';

export const MailCodeSavingsOffer = ({
  currentPayment,
  newPayment,
  potentialSavings,
}: MailCodeSavingsOfferProps): ReactNode => {
  const { t } = useTranslation();

  return (
    <div
      className="mail-code-savings-offer-container"
      data-testid={locator.components.mailCodeSavingsOffer.root}
    >
      <div>
        <label
          data-testid={
            locator.components.mailCodeSavingsOffer.originalPaymentLabel
          }
        >
          <Trans
            components={[<u key={uniqueId('u-')} />]}
            i18nKey={'mailCodeSavingsOffer.estOriginalPayment'}
          />
        </label>
        <span
          data-testid={locator.components.mailCodeSavingsOffer.originalPayment}
        >
          {t('mailCodeSavingsOffer.estOriginalPaymentAmount', {
            amount: currentPayment,
          })}
        </span>
      </div>

      <div>
        <label
          data-testid={
            locator.components.mailCodeSavingsOffer.refinancePaymentLabel
          }
        >
          <Trans
            components={[<u key={uniqueId('u-')} />]}
            i18nKey={'mailCodeSavingsOffer.estRefinancePayment'}
          />
        </label>
        <span
          data-testid={locator.components.mailCodeSavingsOffer.refinancePayment}
        >
          {t('mailCodeSavingsOffer.estRefinancePaymentAmount', {
            amount: newPayment,
          })}
        </span>
      </div>

      <div>
        <label
          data-testid={
            locator.components.mailCodeSavingsOffer.savingsAmountLabel
          }
        >
          <Trans
            components={[<u key={uniqueId('u-')} />]}
            i18nKey={'mailCodeSavingsOffer.estSavings'}
          />
        </label>
        <span
          data-testid={locator.components.mailCodeSavingsOffer.savingsAmount}
        >
          {t('mailCodeSavingsOffer.estSavingsAmount', {
            amount: potentialSavings,
          })}
        </span>
      </div>
    </div>
  );
};
